import { CmsAdDetail } from '../../../../components/Cms';

export function CmsAdDetails() {
  return <CmsAdDetail />;
}
